var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.08334 14.0833H10.9167V8.58331H9.08334V14.0833ZM10 6.74998C10.2597 6.74998 10.4776 6.66198 10.6536 6.48598C10.829 6.31059 10.9167 6.09303 10.9167 5.83331C10.9167 5.57359 10.829 5.35573 10.6536 5.17973C10.4776 5.00434 10.2597 4.91665 10 4.91665C9.74029 4.91665 9.52273 5.00434 9.34734 5.17973C9.17134 5.35573 9.08334 5.57359 9.08334 5.83331C9.08334 6.09303 9.17134 6.31059 9.34734 6.48598C9.52273 6.66198 9.74029 6.74998 10 6.74998ZM10 18.6666C8.73195 18.6666 7.54029 18.4259 6.42501 17.9443C5.30973 17.4634 4.33959 16.8104 3.51459 15.9854C2.68959 15.1604 2.03662 14.1903 1.55568 13.075C1.07412 11.9597 0.833344 10.768 0.833344 9.49998C0.833344 8.23192 1.07412 7.04026 1.55568 5.92498C2.03662 4.8097 2.68959 3.83956 3.51459 3.01456C4.33959 2.18956 5.30973 1.53629 6.42501 1.05473C7.54029 0.573785 8.73195 0.333313 10 0.333313C11.2681 0.333313 12.4597 0.573785 13.575 1.05473C14.6903 1.53629 15.6604 2.18956 16.4854 3.01456C17.3104 3.83956 17.9634 4.8097 18.4443 5.92498C18.9259 7.04026 19.1667 8.23192 19.1667 9.49998C19.1667 10.768 18.9259 11.9597 18.4443 13.075C17.9634 14.1903 17.3104 15.1604 16.4854 15.9854C15.6604 16.8104 14.6903 17.4634 13.575 17.9443C12.4597 18.4259 11.2681 18.6666 10 18.6666Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.ad59b7a3c23d2d6725b2c25076648cc5.svg";
export { ForwardRef as ReactComponent };